<template lang="pug">
  #app
    router-view
</template>

<script>

export default {
  name: 'App',
}
</script>
<style>
	.hzIptResult, input:not([type]), input[type=date], input[type=number], input[type=password], input[type=text], input[type=url], select, textarea {
		font: 400 12px Arial;
	}
</style>


// WEBPACK FOOTER //
// src/App.vue